import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Criteria from './Criteria.vue';
import Analyzers from './Analyzers.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CONVERSATION_ANALYSIS,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/analysis'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'analysis_wrapper',
          meta,
          redirect: to => ({
            name: 'analysis_criteria_index',
            params: to.params,
          }),
        },
        {
          path: 'criteria',
          name: 'analysis_criteria_index',
          meta,
          component: Criteria,
        },
        {
          path: 'analyzers',
          name: 'analysis_analyzers_index',
          meta,
          component: Analyzers,
        },
      ],
    },
  ],
};
